module.exports = __webpack_public_path__ + "img/provider6.abe6a097.png";